export type SalesLinkTemplateId = "classic" | "editorial" | "showcase";

export interface SalesLinkDraft {
  templateId: SalesLinkTemplateId;
  colors: { primary: string; secondary: string; accent: string };
  hero: { title: string; subtitle: string };
  announcements: {
    enabled: boolean;
    text: string;
    backgroundColor: string;
    textColor: string;
  };
  layoutOptions: {
    showHero: boolean;
    showCategories: boolean;
    showSearch: boolean;
    showSocialLinks: boolean;
  };
  banner: { enabled: boolean; imageUrl: string };
}

export interface SalesLinkConfig {
  activeTemplateId: SalesLinkTemplateId;
  templates?: unknown[];
}

export const SALES_LINK_TEMPLATES: {
  id: SalesLinkTemplateId;
  name: string;
  detail: string;
}[] = [
  {
    id: "classic",
    name: "Classic",
    detail: "Cover photo, round logo, and a centered profile. This is the current sales link.",
  },
  {
    id: "editorial",
    name: "Editorial",
    detail: "A magazine masthead, a large image, and a calmer product grid.",
  },
  {
    id: "showcase",
    name: "Showcase",
    detail: "The catalog leads. Your name and photo sit beside the first screen.",
  },
];

export const PREVIEW_MESSAGE = "sqale-preview";
export const PREVIEW_READY = "sqale-preview-ready";

export function normalizeTemplateId(value: unknown): SalesLinkTemplateId {
  return value === "editorial" || value === "showcase" ? value : "classic";
}

export function templateToStoredName(id: SalesLinkTemplateId) {
  return id === "classic" ? "simple" : id;
}

export function emptySalesLinkConfig(): SalesLinkConfig {
  return { activeTemplateId: "classic", templates: [] };
}

export function isPreviewFrame() {
  if (typeof window === "undefined") return false;
  return new URLSearchParams(window.location.search).get("preview") === "1";
}
